import React, { FC, ReactNode } from 'react'
import { Link, useParams } from 'react-router-dom'
import { SideMenuParentArrowIcon } from '@sistemiv/s-components'
import ProjectFolderIcon from '../../assets/ProjectFolderIcon'
import classNames from 'classnames'
import { useProjectsStructure } from '../../repositories/project/projects-structure.repository'
import SideMenuList from './SideMenuList'

type SideMenuProps = {
  children?: ReactNode
}

const SideMenu: FC<SideMenuProps> = () => {
  const { org } = useParams()
  const { data: projects } = useProjectsStructure()

  return (
    <div
      className='flex-none min-h-full w-64 pt-2 overflow-x-auto overflow-y-auto right-auto border-r border-gray-300'
      data-testid='side-menu'
    >
      <Link
        to={`/${org}`}
        className={classNames(
          'flex items-center cursor-pointer hover:bg-sky-50',
          'active:text-white relative [&_svg]:active:fill-white leading-5 gap-x-3 px-9 py-3.5 bg-blue-500 text-white [&_svg]:fill-white hover:!bg-blue-500', // Additional styles
        )}
        data-testid='side-menu-item' // TODO pitaj JK : side menu item je imao taj data-testid a link sam po sebi nema pa sam ga ja dodao, ali sta ce nam ovo ?? i zasto milica pise testove za front a ne mi?
      >
        {projects?.length && projects?.length > 0 && (
          <span className='absolute inset-0 inline-flex items-center left-4'>
            <SideMenuParentArrowIcon className='w-3 h-3 fill-black rotate-90' />
          </span>
        )}
        <ProjectFolderIcon className='w-5 h-5' />
        Studio
      </Link>

      {projects && <SideMenuList projects={projects} />}
    </div>
  )
}

export default SideMenu
